<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { BASE_URL } from '@yld/yun-utils-host'
import { updateThemeColor } from '@/utils/primaryColor'
export default {
  name: 'App',
  created() {
    var link = document.querySelector('link[rel*="icon"]')
    // 全球捷运定制
    if (BASE_URL.DOMAIN_URL.indexOf('worldex.com.cn') > -1) {
      link.href = 'https://yldfiles.geekyum.com/fe/imgs/worldex_favicon.ico'
      document.body.style.setProperty('--geek-color-primary', '#496DCF')
      updateThemeColor('#496DCF')
    } else if (BASE_URL.DOMAIN_URL.indexOf('topasia.cc') > -1) {
      // 冠亚定制
      link.href = 'https://yldfiles.geekyum.com/fe/imgs/topasia_favicon.ico'
      document.body.style.setProperty('--geek-color-primary', '#1B99E7')
      updateThemeColor('#1B99E7')
    } else {
      // link.href = 'https://yldfiles.geekyum.com/fe/imgs/favicon.ico'
      link.href = 'https://hzhfiles.oss-cn-beijing.aliyuncs.com/fe/imgs/favicon.ico'
    }
  }
}
</script>
